import { createModel } from '@rematch/core';
import { RootModel } from '../root';
import type { UserState } from './user.model';
import reducers from './user.reducers';
import effects from './user.effects';

const initialState: UserState = {
  id: null,
  language: 'pl',
  firstName: '',
  firstNameVocative: '',
  lastName: '',
  email: '',
  peselGender: 'M',
  token: null,
  userStatus: null,
  kisaUserStatus: null,
  regulationsAcceptanceRequired: false,
  showContactDetailsAcceptance: false,
  impersonation: false,
  showUserAccountActivatedMessage: false
};

const userModel = createModel<RootModel>()({
  state: initialState,
  reducers,
  effects
});

export default userModel;
